import { TranslatableText } from '@dreryk/react-common';

import { translationKeys } from '../translations';
import { PatientAuthorization } from '../types';

import { patientAuthorizationIdentifierVisitor } from './patientAuthorizationIdentifierVisitor';

export const getPatientAuthorizationIdentifierTypeTranslableText = (
   patientAuthorization: PatientAuthorization
): TranslatableText =>
   patientAuthorizationIdentifierVisitor(patientAuthorization, {
      visitBirthDate: () => translationKeys.identifierTypeMap.BIRTH_DATE,
      visitNationalIdentificationNumber: () => translationKeys.identifierTypeMap.NATIONAL_IDENTIFICATION_NUMBER,
      visitPassport: () => translationKeys.identifierTypeMap.PASSPORT,
      visitPesel: () => translationKeys.identifierTypeMap.PESEL,
   });
